import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-tools"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("polyline", {
      points: "22.1,20.1 30.3,12 31.6,10 33.8,9.7 33.5,11.9 31.5,13.2 23.4,21.4 ",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1),
    _createElementVNode("line", {
      x1: "30.3",
      x2: "31.5",
      y1: "12",
      y2: "13.2",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.2,19.2L9.9,30.5l0,0l0,0c-0.9,0.9-0.9,2.2,0,3.1c0.9,0.9,2.2,0.9,3.1,0l0,0l0,0l11.3-11.3",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.4,24.2l5.5,5.6c-0.3,0.9-0.3,1.8,0.1,2.7c0.8,1.8,2.9,2.6,4.6,1.8L30.3,32c-0.2-0.2-0.2-0.6,0-0.8l0.9-0.9\n\tc0.2-0.2,0.6-0.2,0.8,0l0,0l2.2,2.2c0.4-0.9,0.4-2,0-2.9c-0.8-1.7-2.7-2.5-4.4-1.8l-6.1-6.1l-1-1l-0.2-0.2l-6.1-6.1l0,0\n\tc0.3-0.9,0.3-1.8-0.1-2.7c-0.8-1.8-2.9-2.6-4.6-1.8l2.2,2.2c0.2,0.2,0.2,0.6,0,0.8L13,13.8c-0.2,0.2-0.6,0.2-0.8,0l0,0L10,11.6\n\tc-0.4,0.9-0.4,2,0,2.9c0.8,1.7,2.7,2.5,4.4,1.8l0,0l4.9,4.8",
      class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
    }, null, -1)
  ]), 16))
}
export default { render: render }